/**
 * Hotjar analytics loader.
 * Injects the stub and loads the script when called (e.g. from a hook or app mount).
 */

export type HotjarStub = ((...args: unknown[]) => void) & { q: unknown[] };

declare global {
  interface Window {
    hj?: HotjarStub;
    _hjSettings?: { hjid: number; hjsv: number };
  }
}

const HOTJAR_SITE_ID = 6406038;
const HOTJAR_SCRIPT_VERSION = 6;
const HOTJAR_BASE_URL = 'https://static.hotjar.com/c/hotjar-';
const HOTJAR_SCRIPT_SUFFIX = '.js?sv=';

export function loadHotjar(): void {
  if (window.hj) {
    return;
  }

  const hjStub: HotjarStub = Object.assign(
    function (...args: unknown[]) {
      (hjStub.q = hjStub.q || []).push(args);
    },
    { q: [] as unknown[] }
  );

  window.hj = hjStub;
  window._hjSettings = { hjid: HOTJAR_SITE_ID, hjsv: HOTJAR_SCRIPT_VERSION };

  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  script.async = true;
  script.src = `${HOTJAR_BASE_URL}${HOTJAR_SITE_ID}${HOTJAR_SCRIPT_SUFFIX}${HOTJAR_SCRIPT_VERSION}`;
  head.appendChild(script);
}
